import { Platform, StyleSheet, Dimensions } from 'react-native';

const { width, height } = Dimensions.get('window');
const isTablet = width >= 768; // iPad and larger tablets are typically 768px or wider

export const actionPlanDetailsStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f9ff',
  },
  mainScrollView: {
    flex: 1,
    backgroundColor: '#f5f9ff',
  },
  mainScrollContent: {
    paddingHorizontal: Platform.OS === 'web' ? '2%' : 16,
    paddingTop: 16,
    paddingBottom: 32,
  },
  headerSection: {
    flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    justifyContent: 'space-between',
    alignItems: Platform.OS === 'web' ? 'center' : 'stretch',
    marginBottom: (Platform.OS === 'web'||isTablet) ? 24 : 8,
    marginLeft: Platform.OS === 'web' ? 20 : 0,
    gap: 16,
    marginRight: Platform.OS === 'web' ? 0 : 16,
    paddingBottom: Platform.OS === 'web' ? 0 : 0,
  },
  headerLeft: {
    flex: Platform.OS === 'web' ? 1 : undefined,
    width: '100%',
    marginRight: Platform.OS === 'web' ? 16 : 0,
    justifyContent: 'flex-start',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  backButton: {
    paddingRight: 8,
    paddingLeft: Platform.OS === 'web' ? 0 : 8,
    paddingVertical: 8,
    marginBottom: 12,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    minHeight: 40,
    minWidth: 140,
    zIndex: 2,
  },
  backButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#005CBC',
    marginLeft: 8,
  },
  headerTitle: {
    fontSize: 28,
    fontWeight: '700',
    color: '#1f1f1f',
    marginBottom: Platform.OS === 'web' ? 8 : 4,
    marginRight: 8,
    flexWrap: 'wrap',
    maxWidth: '100%',
    lineHeight: 34,
    paddingLeft: Platform.OS === 'web' ? 0 : (isTablet ? 14 : 10),

  },
  headerButtons: {
    marginTop: Platform.OS === 'web' ? 50 : 8,
    flexDirection: (Platform.OS === 'web' || isTablet) ? 'row' : 'column',
    marginHorizontal: Platform.OS === 'web' ? 0 : -8,
    width: Platform.OS === 'web' ? undefined : '100%',
    paddingHorizontal: Platform.OS === 'web' ? 0 : 8,
    gap: (Platform.OS === 'web' || isTablet) ? 12 : 8,
    paddingLeft: Platform.OS === 'web' ? 0 : (isTablet ? 14 : 20),

  },
  primaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: (Platform.OS === 'web' || isTablet) ? 'flex-start' : 'center',
    backgroundColor: '#034895',
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: '#034895',
    marginBottom: (Platform.OS === 'web' || isTablet) ? 0 : 0,
    width: (Platform.OS === 'web' || isTablet) ? undefined : '100%',
  },
  primaryButtonText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#FFFFFF',
    marginLeft: 8,
  },
  secondaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: (Platform.OS === 'web' || isTablet) ? 'flex-start' : 'center',
    backgroundColor: '#FBFCFE',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: '#005CBC',
    marginBottom: (Platform.OS === 'web' || isTablet) ? 0 : 0,
    width: (Platform.OS === 'web' || isTablet) ? undefined : '100%',
  },
  secondaryButtonText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#005CBC',
    marginLeft: 8,
  },
  tertiaryButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: (Platform.OS === 'web' || isTablet) ? 'flex-start' : 'center',
    backgroundColor: 'transparent',
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 24,
    marginBottom: (Platform.OS === 'web' || isTablet) ? 0 : 0,
    width: (Platform.OS === 'web' || isTablet) ? undefined : '100%',
  },
  tertiaryButtonText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#034895',
    marginLeft: 8,
  },
  content: {
    flex: 1,
    padding: 16,
  },
  contentWrapper: {
    flexDirection: (Platform.OS === 'web' || isTablet) ? 'row' : 'column',
    gap: 24,
  },
  contentPlaceholder: {
    flex: Platform.OS === 'web' ? 0.65 : (isTablet ? 0.5 : 1),
    paddingBottom: 32,
  },
  auditHistoryPlaceholder: {
    flex: Platform.OS === 'web' ? 0.35 : (isTablet ? 0.5 : 1),
    paddingBottom: 32,
  },
  placeholderText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#666666',
    marginBottom: 8,
  },
  placeholderSubText: {
    fontSize: 14,
    color: '#999999',
  },
  footer: {
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
    backgroundColor: '#ffffff',
  },
  closeButton: {
    backgroundColor: '#666666',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 4,
    alignItems: 'center',
  },
  closeButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#ffffff',
  },
  auditTrailModalContainer: {
    flex: 1,
    backgroundColor: 'transparent',
    justifyContent: 'flex-end',
  },
  auditTrailModalBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  auditTrailModalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    height: height * 0.85,
    maxHeight: height * 0.85,
    paddingHorizontal: 0,
    paddingVertical: 0,
    flexDirection: 'column',
    overflow: 'hidden',
  },
  auditTrailModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
    backgroundColor: '#ffffff',
    minHeight: 54,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  auditTrailModalTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#1f1f1f',
    flex: 1,
    paddingRight: 12,
  },
  auditTrailModalCloseButton: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  auditTrailModalScroll: {
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
  },
  auditTrailModalGoBackButton: {
    backgroundColor: '#034895',
    marginHorizontal: 16,
    marginBottom: 16,
    marginTop: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  auditTrailModalGoBackButtonText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#ffffff',
  },
  topOpportunityToggle: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: Platform.OS === 'web' ? 0 : 8,
    marginBottom: Platform.OS === 'web' ? 0 : 4,
  },
  topOpportunityLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    marginRight: 8,
  },
});
